import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
//custom imports
import styles from '../../../assets/stylesheets/pages/project/project.module.scss'
import Table from '../../../uicomponents/table/Table'
import Datepicker from '../../../uicomponents/date-picker'
import { getCallsOfCaller, getLastAuditDate } from './service'
import useApi from '../../../hooks/useApi'
import Heading from '../../../uicomponents/heading'
import handleErrorMessage from '../../../helper/handleErrorMessage'
import { UserIcon, DataCollection, TrackHistory, AttachmentIcon, StatsIcon } from '../../../assets/images'
import CustomTooltip from '../../../components/utilities/ToolTip'
import Dropdown from 'react-dropdown';
import Popup from '../../../uicomponents/popup'
import CustomTab from '../../../components/utilities/CustomTab'
import CustomerInfo from '../../../components/utilities/CustomerInfo'
import ApiActions from "../../../actions/ApiActions"
import ThreeDotLoader from "../../../components/utilities/ThreeDotLoader"
import ProjectTitle from '../../../components/common/ProjectTitle';
import CallDisconnectedBy from "../../../helper/CallDisconnectedBy";
import QCInsights from '../qcInsights';

const popupTabs = [
    {
        label: 'Data collection',
        value: 'data_collection'
    },
    {
        label: 'Call history',
        value: 'call_history'
    },
    {
        label: 'Customer info',
        value: 'customer_info'
    }
]
const formatSecondsToMMSS = (seconds) => {
    if (seconds === undefined || seconds === null || isNaN(seconds)) return 'NA';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const formattedMins = mins.toString().padStart(2, '0');
    const formattedSecs = secs.toString().padStart(2, '0');
    return `${formattedMins}:${formattedSecs} min`;
};

const CallsListOfCaller = (props) => {
    const {state: {query, outcomeQuery}} = props.location
    const searchBy = query
    const outcome = outcomeQuery

    if(!props.location.state){
        props.history.push({
            pathname: `/audit/v2`,
        })
        return true
    }

    const compareDateToGetLatest = () => {
    const { retrainingDate, iqcClearDate } = props.location.state.callerDetails;

    const dates = [];

    if (retrainingDate !== 'NA') {
        dates.push(moment(retrainingDate));
    }

    if (iqcClearDate !== 'NA') {
        dates.push(moment(iqcClearDate));
    }

    return moment.max(dates);
};

const latestDate = compareDateToGetLatest();
const increaseRetrainingDate = latestDate ? latestDate.add(1, 'day').toDate().toISOString() : ''

    const {state: {callPage}} = props.location
    const getCallsOfCallerApi = useApi(getCallsOfCaller)
    const fetchLastAuditDate = useApi(getLastAuditDate)
    const [skip, setSkip] = useState(0)
    const [limit, setLimit] = useState(10)
    const [sort, setSort] = useState([])
    const [search, setSearch] = useState('')
    const [leadIdSearch, setLeadIdSearch] = useState('');
    const [leadIdError, setLeadIdError] = useState('');
    const [hasFiltersApplied, setHasFiltersApplied] = useState(false);
    const [currentPage, setCurrentPage] = useState(callPage ? callPage : 1);
    const [fromDate, setFromDate] = useState(increaseRetrainingDate ? moment.max([moment(increaseRetrainingDate),moment().subtract(7, 'days')]).toDate() : '')
    const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [selectOutcome, setSelectOutcome] = useState(outcome ? outcome : '')
    const [showCallInfo, setShowCallInfo] = useState(false)
    const [selectedRowData, setSelectedRowData] = useState()
    const [activeTab, setActiveTab] = useState({
        label: popupTabs[0].label,
        value: popupTabs[0].value
    })
    const [qcinsightsModal, setqcinsightsModal] = useState({
        show: false,
        data: ''
    })

    const { title, name, userId } = props.location.state.callerDetails
    useEffect(() => {
        addParamToUrl()
        const skip = (currentPage - 1) * limit
        const data = {
            userId: props.location.state.callerDetails.userId,
            teleprojectId: props.location.state.callerDetails.teleprojectId,
            from: fromDate ? moment(fromDate).format("DD/MM/YYYY") : '',
            to: toDate ? moment(toDate).format("DD/MM/YYYY") : '',
            outcome: selectOutcome || undefined,
            leadId: leadIdSearch.trim() ? leadIdSearch.trim().toLowerCase() : undefined
        }
        getCallsOfCallerApi.request(skip, limit, sort, search, data)
    }, [currentPage, sort, search, fromDate, toDate, selectOutcome])

    useEffect(() => {
        const userId = props.location.state.callerDetails.userId
        const teleprojectId = props.location.state.callerDetails.teleprojectId
        fetchLastAuditDate.request(userId,teleprojectId)
    },[])

    const isInteger = (value = '') => {
        return /^-?\d+$/.test(value)
    }

    const addParamToUrl = () => {
        if(selectOutcome){
            props.history.push({
                pathname: `${props.location.pathname}`,
                state: {
                    callerDetails: props.location.state.callerDetails,
                    activeTab: props.location.state.activeTab,
                    page: props.location.state.page,
                    query: searchBy,
                    outcomeQuery: selectOutcome,
                    leadIdQuery: leadIdSearch
                }
            })
        }else{
            props.history.push({
                pathname: `${props.location.pathname}`,
                state: {
                    callerDetails: props.location.state.callerDetails,
                    activeTab: props.location.state.activeTab,
                    page: props.location.state.page,
                    query: searchBy,
                    outcomeQuery: selectOutcome,
                    leadIdQuery: leadIdSearch
                }
            })
        }
    }
    const handleLeadIdSearch = (e) => {
        const value = e.target.value;
        if (/^[a-zA-Z0-9]*$/.test(value)) {
            setLeadIdSearch(value);
            setLeadIdError('');
        } else {
            setLeadIdError('Invalid input. Only alphanumeric characters allowed.');
        }
    };

    const handleLeadIdSearchSubmit = (e) => {
        if (e.key === 'Enter') {
            const value = leadIdSearch.trim();
            if (value === '') {
                return;
            }
            if (!/^[a-zA-Z0-9]*$/.test(value)) {
                setLeadIdError('Invalid input. Only alphanumeric characters allowed.');
                return;
            }
            setCurrentPage(1);
        }
    };


    const copyToClipboard = (recordingUrl) => {
        navigator.clipboard.writeText(recordingUrl);
    }

    const columns = [
        {
            Header: 'S.No',
            width: "1%",
            Cell: (cell) => {
                return <span>{((currentPage - 1) * limit) + (Number(cell.row.id) + 1)}</span>
            },
            disableSortBy: true
        },
        {
            Header: 'Audio',
            accessor: 'recordingUrl',
            Cell: ({ value }) => {
                return value ?
                    <div className={styles.audio_copy_link}>
                        <audio controls src={value} />
                        <CustomTooltip placement={'bottom'} description={'Copy audio link'}
                            component={
                                <img title="Copy link" className='mock-record-url' src={AttachmentIcon}
                                    onClick={() => copyToClipboard(value)}
                                    alt='copy audio link' />
                            }
                        />
                    </div>
                    : 'NA'
            },
            width: "10%",
            disableSortBy: true
        },
        {
            Header: 'LeadId',
            accessor: 'leadId',
            Cell: ({ value }) => {
                if (leadIdSearch && leadIdSearch.length > 3 && value && value.toLowerCase().includes(leadIdSearch.toLowerCase())) {
                    const escapedSearch = leadIdSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    const regex = new RegExp(`(${escapedSearch})`, 'gi');
                    const parts = value.split(regex);
                    return (
                        <span style={{ whiteSpace: 'nowrap' }}>
                            {parts.map((part, i) =>
                                regex.test(part) ?
                                    <span key={i} style={{ 
                                        backgroundColor: '#ffeb3b',
                                        display: 'inline'
                                    }}>{part}</span> :
                                    <span key={i} style={{ display: 'inline' }}>{part}</span>
                            )}
                        </span>
                    );
                }
                return <span style={{ whiteSpace: 'nowrap' }}>{value || 'NA'}</span>;
            },
            width: "8%",
            disableSortBy: true
        },
        {
            Header: 'Outcome',
            accessor: 'outcome',
            Cell: ({ value }) => `${value && value.title || 'NA'}`,
            width: "8%",
            disableSortBy: true
        },
        {
            Header: 'Call Date',
            accessor: 'createdAt',
            Cell: ({ value }) => (<span>{moment(value).format("DD/MM/YYYY")} | {moment(value).format('hh:mm A')}</span> || 0),
            width: "9%",
            disableSortBy: true
        },
        {
            Header: 'Disconnected by',
            accessor: 'disconnectedBy',
            Cell: ({ value }) => CallDisconnectedBy(value || ''),
            width: "9%",
            disableSortBy: true
        },
        {
            id: "expander",
            /*  Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
                <span {...getToggleAllRowsExpandedProps()}>
                  {isAllRowsExpanded ? "👇" : "👉"} Actions
                </span>
              ),*/
            Header: 'Actions',
            accessor: "action",
            // expander: true,
            Cell: (row, rows, toggleRowExpanded) => {
                return (
                    <div style={{ display: 'flex', gap: '2em' }}>
                        <CustomTooltip placement={'bottom'} description={'Data collection'}
                            component={<img src={DataCollection} width='18px'
                                alt='Data collection'
                                onClick={() => getRowData(row.cell.row.original, popupTabs[0].value)} />}
                        ></CustomTooltip>
                        <CustomTooltip placement={'bottom'} description={'Call history'}
                            component={<img src={TrackHistory} width='18px'
                                alt='Call history'
                                onClick={() => getRowData(row.cell.row.original, popupTabs[1].value)} />}>
                        </CustomTooltip>
                        <CustomTooltip placement={'bottom'} description={'Customer info'}
                            component={<img src={UserIcon} width='18px'
                                alt='Customer info'
                                onClick={() => getRowData(row.cell.row.original, popupTabs[2].value)} />}>
                        </CustomTooltip>
                        <CustomTooltip placement={'bottom'} description={'Caller vs System performance avg'}
                            component={<img src={StatsIcon} width='18px'
                                alt='Caller vs System performance avg'
                                onClick={() => {
                                    setqcinsightsModal({show: true, data: {
                                        teleproject: props.location.state && props.location.state.callerDetails && props.location.state.callerDetails.teleprojectId,
                                        userId: props.location.state && props.location.state.callerDetails && props.location.state.callerDetails.userId
                                    }})
                                    }} />}>
                        </CustomTooltip>   
                    </div>
                )
            },
            /*Cell: ({ row }) => (
                 <span {...row.getToggleRowExpandedProps()}>
                   {row.isExpanded ? "👇" : "👉"}
                 </span>
           ),*/
            width: "15%",
            disableSortBy: true
        },
        {
            Header: 'QMF',
            accessor: 'qmf',
            Cell: (cell) => <div onClick={() => checkToAudit(cell.row.original)} className={styles['arrow']}><FontAwesomeIcon icon={faCaretRight} /></div>,
            width: "2%",
            disableSortBy: true
        },
    ]
    // const CallDisconnectedBy = (value) => {
    //     if (!value || typeof value !== 'object') {
    //         return 'NA';
    //     }
    //     const { direction, disconnectedBy } = value;
    //     if (direction === 'incoming') {
    //         if (disconnectedBy === 'callee') {
    //             return 'Tele-caller';
    //         } else if (disconnectedBy === 'caller') {
    //             return 'Customer';
    //         }
    //     } else if (direction === 'outgoing') {
    //         if (disconnectedBy === 'callee') {
    //             return 'Customer';
    //         } else if (disconnectedBy === 'caller') {
    //             return 'Tele-caller';
    //         }
    //     }
    //     return 'NA';
    // }

    const Calendar = () => {
    return (
        <Datepicker
        placeholderText="Click to select a date"
        isDateRange={true}
        from={fromDate ? moment(fromDate).toDate() : null}
        to={toDate ? moment(toDate).toDate() : null}
        minDate={moment.max([moment(increaseRetrainingDate), moment().subtract(1, 'month')]).toDate()}
        selectedDate={fromDate === '' ? moment().toDate() : fromDate}
        maxDate={moment().toDate()}                
        onChange={(daterange) => {
            const [from, to] = daterange;

            if (from && to) {
            setFromDate(moment(from).format("YYYY-MM-DD"));
            setToDate(moment(to).format("YYYY-MM-DD"));
            setCurrentPage(1);
            filterChange("");
            }
        }}
        />
    );
    };

    const checkToAudit = async (rowData) => {
        const { teleprojectId, userId } = props.location.state.callerDetails
        try {
            const result = await ApiActions.getApplicantList({
                teleproject: teleprojectId,
                user: userId
            })
            if (result && !['inprogress', 'onhold'].includes(result[0].status)) {
                toast('The caller is not in selected stage')
            } else {
                props.history.push({
                    pathname: `/audit/v2/qmf/qmf-form/${userId}`,
                    state: {
                        callerDetails: props.location.state.callerDetails,
                        callDetails: rowData,
                        activeTab: props.location.state.activeTab,
                        page: props.location.state.page,
                        callPage: currentPage,
                        query: searchBy,
                        outcomeQuery: selectOutcome
                    }
                })
            }
        } catch (error) {
            console.error(error)
        }
    }

    const getRowData = async (rowData, tabName) => {
        if (selectedRowData) {
            setActiveTab(popupTabs.find(pop => pop.value == tabName))
            setShowCallInfo(true)
        }
        else {
            //get call history
            try {
                let result = await ApiActions.getTeletaskCallHistory({
                    teletaskHistory: rowData && rowData._id
                })
                rowData['callHistory'] = result
                setSelectedRowData(rowData)
            } catch (err) {
                console.error((err.response && err.response.data) || "Unexpected Error!")
            } finally {
                setSelectedRowData(rowData)
                setActiveTab(popupTabs.find(pop => pop.value == tabName))
                setShowCallInfo(true)
            }
        }
    }

    const filterChange = (searchInput) => {
        setSearch(searchInput)
        setCurrentPage(1)
        setHasFiltersApplied(searchInput !== '' || selectOutcome !== '' || !!fromDate || !!toDate);
    }

    const sortChange = (sortArray) => {
        if (sortArray !== '')
            setSort(sortArray)
        if (sortArray === '' && sort.length == 1)
            setSort([])
    }

    const renderCallInfo = () => {
        const setActiveTabFn = (activeTab, activeRow) => {
            setActiveTab({
                label: activeTab.label,
                value: activeTab.value
            })
        }

        const showDC = () => {
            let dataCollection = selectedRowData && ((selectedRowData.outcome && selectedRowData.outcome.responses) || selectedRowData.responses)
                ? selectedRowData.responses
                    ? selectedRowData.responses
                    : selectedRowData.outcome && selectedRowData.outcome.responses
                : false;
            return dataCollection && dataCollection.length > 0
                ? <div className='data-collection-question'>
                    {
                        dataCollection.map((item, index) => {
                            return (
                                <div key={index} className="question-div">
                                    <p className="question" style={{ fontWeight: "bold" }}>{`Q.${index + 1} ${item.question}`}</p>
                                    <p className="answer">Ans: {item.answer}</p>
                                </div>
                            )
                        })
                    }
                </div>
                : <span>No Data collection present</span>
        }

        const showCustInfo = () => {
            return <CustomerInfo info={selectedRowData} />
        }

        const showCallHistory = () => {
            return selectedRowData && selectedRowData.callHistory &&
                selectedRowData.callHistory.length > 0 ?
                <div className={styles["audio-wrap"]}>
                    {
                        selectedRowData.callHistory.map((ai, i) => {
                            return (
                                <div className={styles['call-attempted']}>
                                    <div className={styles['details']}>
                                        <span>Attempt {ai.attempts}: {
                                            ai.outcome && ai.outcome.title ? ai.outcome.title : ai.callstatus
                                        }</span>
                                        {
                                            ai.recordingUrl ? <audio controls src={ai.recordingUrl}></audio> : null
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div> : <h6>No audio files</h6>
        }

        return (
            <Popup
                show={showCallInfo}
                closePopup={() => {
                    setSelectedRowData('')
                    setActiveTab({
                        label: popupTabs[0].label,
                        value: popupTabs[0].value
                    })
                    setShowCallInfo(false)
                }}
                size='sm'
                heading={<CustomTab tabs={popupTabs} setActiveTabFn={(data) => setActiveTabFn(data, selectedRowData)}
                currentTab = {activeTab}
                className={'navy-blue'} />}
            >
                <div className={styles['call-detail-wrapper']}>
                <div className={styles['call-audio-info']}>
                    <div className={styles.audio_copy_link}>
                        <audio controls src={selectedRowData.recordingUrl} />
                        <CustomTooltip placement={'bottom'} description={'Copy audio link'}
                            component={
                                <img title="Copy link" className='mock-record-url' src={AttachmentIcon}
                                    onClick={() => copyToClipboard(selectedRowData.recordingUrl)}
                                    alt='copy audio link' />
                            }
                        />
                    </div>
                    <div className={styles['info']}>Outcome: {selectedRowData.outcome.title} | Call Date: {<span>{moment(selectedRowData.createdAt).format("DD/MM/YYYY")} at {moment(selectedRowData.createdAt).format('HH:mm')}</span> || 0} | Disconnected by: {selectedRowData.disconnectedBy}</div>
                </div>
                <div className={styles['horizontal-divider']}></div>
                {
                    selectedRowData ? <div>
                        {activeTab.value == 'data_collection' ? showDC() : null}
                        {activeTab.value == 'customer_info' ? showCustInfo() : null}
                        {activeTab.value == 'call_history' ? showCallHistory() : null}
                    </div> : <ThreeDotLoader />
                }
                </div>
            </Popup>
        )
    }

    const renderQCInsights = () => {
        return(
            <Popup
            show={qcinsightsModal.show}
            closePopup={()=>{
                setqcinsightsModal({show: false, data: ''})
            }}
            size='lg'
            heading={'QC Insights'}
             >
            <QCInsights details={qcinsightsModal.data} />
            </Popup>
        )
    }

    const handlePopups = () => {
        if (showCallInfo) return renderCallInfo()
        if(qcinsightsModal.show) return renderQCInsights()
    }

    let { data, total, auditInfo } = getCallsOfCallerApi.data || {}
    const { loading, error } = getCallsOfCallerApi
    const lastAuditDate = fetchLastAuditDate.data && fetchLastAuditDate.data[0] && fetchLastAuditDate.data[0].createdAt && moment(fetchLastAuditDate.data[0].createdAt).add(5.5, "hours").format("DD-MM-YYYY") || 'NA'

    useEffect(() => {
        if (error)
            toast(handleErrorMessage(error))
    }, [error])


    const defineoutcomes = () => {
        let dynamic = props.location.state.callerDetails.outcomes.map(i => {
            return { label: (`${i.title}${i.allowed === 'none' ? ' (Turned off) ' : ''}`).trim(), value: i.title }
        })
        let result = [
            { label: 'All outcomes', value: 'All outcomes' },
            ...dynamic
        ]
        return result
    }

    return (
        <div className={styles.page_wrapper}>
            <Heading text={
                <ProjectTitle title={
                    <ul className={styles.breadcrumbs}>
                        <li>QMF</li>
                        <li>{title}</li>
                        <li>Max HT: {formatSecondsToMMSS(props.location.state.callerDetails.maxTimeLimit)}</li>
                        <li>{name}</li>
                    </ul>
                }
                    goBack={() => {
                        props.history.push({
                            pathname: '/audit/v2',
                            state: {
                                activeTab: props.location.state.activeTab,
                                query: props.location.state.query,
                                outcomeQuery: selectOutcome,
                                page: props.location.state.page
                            }
                        })
                    }} />
            } />

            <div className={styles.qmf_row}>
                <div className={styles.audit}>
                    <div className={styles.audit_info}>{auditInfo && auditInfo.auditCount || 0} / {auditInfo && auditInfo.maxCallsToAudit || 0}</div>
                    <span className={styles.text_muted}>audits this week (Last audited on : {lastAuditDate})</span>
                </div>
                <div className={styles.right_end}>
                <div className={styles.lead_id_search}>
                    <input
                    type="text"
                    placeholder="Search by Lead ID"
                    value={leadIdSearch}
                    onChange={handleLeadIdSearch}
                    onKeyPress={handleLeadIdSearchSubmit}
                    />
                    {leadIdError && (
                    <div className={styles.error_message} style={{ color: 'red' }}>
                        {leadIdError && <div className={styles.error_message}>Invalid input. Only alphanumeric characters allowed.</div>}
                    </div>
                    )}
                    {!loading && leadIdSearch.trim() !== '' && Array.isArray(data) && data.length === 0 && (
                    <div className={styles.error_message} style={{ color: 'red' }}>
                        No matching Lead IDs found
                    </div>
                    )}
                    {!loading &&
                    hasFiltersApplied &&
                    leadIdSearch.trim() === '' &&
                    Array.isArray(data) &&
                    data.length === 0 && (
                    <div className={styles.error_message} style={{ color: 'red' }}>
                        No results for current filters
                    </div>
                    )}
                </div>
                    <Dropdown
                        options={defineoutcomes()}
                        onChange={(e) => {
                            setCurrentPage(1)
                            setSelectOutcome(e.value == 'All outcomes' ? '' : e.value)
                        }}
                        value={selectOutcome == '' ? 'All outcomes' : selectOutcome}
                        placeholder="Select an outcome"
                        className="custom-dropdown-audit-select-outcome" />

                    
                    <Calendar />

                    {/* <Datepicker
                        placeholderText="Click to select a date"
                        minDate={moment.max([moment(increaseRetrainingDate), moment().subtract(1, 'month')]).toDate()}
                        selectedDate={fromDate === '' ? moment().toDate() : fromDate}
                        onChange={date => {
                            if (increaseRetrainingDate && moment(date).isSameOrAfter(moment(increaseRetrainingDate))) {
                                setFromDate(date)
                            } else {
                                setFromDate(increaseRetrainingDate ?
                                    moment(increaseRetrainingDate).toDate() : date)
                            }
                        }}
                    /> */}
                </div>
            </div>


            <div>
                {!loading && Array.isArray(data) && data.length === 0 && !hasFiltersApplied && (<div className={styles.noResults}>No data available</div>)}
                <Table
                    columns={columns}
                    data={data}
                    totalCount={total}
                    limit={limit}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    loading={loading}
                    sortChange={sortChange}
                    filterChange={filterChange}
                    searchBy='project title or mobile'
                    isGlobalFilter={false}
                    noDataText={!hasFiltersApplied ? 'No data available' : ''}
                />
            </div>
            <ToastContainer draggable={true} />
            {handlePopups()}
        </div>
    )
}

export default CallsListOfCaller